export default __webpack_public_path__ + "static/media/dislike.ddd8aea6.svg";